import { Role } from "../constant/RoleConstants";

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const getToken = () => {
  const data = localStorage.getItem("sprooze-web");
  return data ? JSON.parse(data).token : null;
};

export const getMediaType = (url) => {
  const imageExtensions = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "tiff",
    "tif",
    "ico",
    "webp",
    "svg",
  ];
  const videoExtensions = [
    "mp4",
    "mov",
    "wmv",
    "avi",
    "flv",
    "mkv",
    "webm",
    "mpeg",
    "mpg",
    "m4v",
    "3gp",
    "3g2",
    "f4v",
    "rm",
    "rmvb",
    "vob",
    "ogv",
  ];
  const extension = url.split(".").pop()?.split("?")[0].toLowerCase();

  if (extension && imageExtensions.includes(extension)) {
    return "image";
  } else if (extension && videoExtensions.includes(extension)) {
    return "video";
  } else {
    throw new Error("Unsupported media type");
  }
};

export const roleBasedRedirection = (path) => {
  const userStatus = JSON.parse(
    localStorage.getItem("sprooze-web") || "{}"
  )?.status;
  return userStatus === Role.HIRING_MANAGER ? `/hiring-manager${path}` : path;
};

export const getStoredUser = () => {
  try {
    const data = localStorage.getItem("sprooze-web");
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const isHiringManagerUser = (user) => {
  const currentUser = user ?? getStoredUser();
  return currentUser?.status === Role.HIRING_MANAGER;
};
